import { ReactNode } from 'react';
import styled, { CSSProperties } from 'styled-components';

import { BodilColor } from '~src/branding';
import { boxShadows } from '~src/branding/boxShadow';
import { useBranding } from '~src/context/BrandingContext';
import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';

import { Icon } from '../Icon';

const Header = styled.div({
  width: '100vw',
  height: '250px',
  position: 'sticky',
  top: '0px',
  zIndex: 100,
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: '16px',
  backgroundColor: BodilColor.base.default,
  borderRadius: '0px 0px 20px 20px',
  transition: 'height .5s',
});

const ChildrenWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
});

const Handle = styled.div({
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, 0)',
  bottom: '0%',
});

type Props = {
  children?: ReactNode;
  collapsedChildren?: ReactNode;
};

type BaseProps = Props & {
  headerStyle?: CSSProperties;
  expandedHeaderStyle?: CSSProperties;
  collapsedHeaderStyle?: CSSProperties;
  chevronColor?: string;
};

const DragDownHeaderBase = ({ children, collapsedChildren, headerStyle, chevronColor }: BaseProps) => {
  const { headerExpanded, setHeaderExpanded } = usePublicCalculatorContext();

  const { darkColor: backgroundColor } = useBranding();

  return (
    <Header
      style={{
        ...(headerExpanded && { height: '100vh', borderRadius: 0 }),
        backgroundColor,
        ...headerStyle,
      }}
    >
      {headerExpanded && <ChildrenWrapper>{children}</ChildrenWrapper>}
      {!headerExpanded && <ChildrenWrapper>{collapsedChildren ?? children}</ChildrenWrapper>}
      <Handle {...{ onClick: () => setHeaderExpanded(!headerExpanded) }}>
        <Icon.Chevron
          width='24px'
          height='24px'
          color={chevronColor ?? 'white'}
          direction={headerExpanded ? 'up' : 'down'}
        />
      </Handle>
    </Header>
  );
};

export const DragDownHeader = (props: Props) => <DragDownHeaderBase {...props} />;

export const DragDownHeaderNorlys = (props: Props) => {
  const backgroundColor = 'white';

  return (
    <DragDownHeaderBase
      {...props}
      {...{
        headerStyle: {
          backgroundColor,
          borderRadius: 0,
          ...boxShadows.norlys,
        },
        expandedHeaderStyle: { backgroundColor },
        collapsedHeaderStyle: { marginBottom: 0 },
        chevronColor: 'black',
      }}
    />
  );
};
